const CAP24 = {
  "id": 47,
  "title": "Otras formas de obtener Bitcoin",
  "slug": "otras-formas-de-obtener-bitcoin",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "Introducción",
      "text": [
        "Además de comprar Bitcoin con dinero fiat o efectivo, existen otras formas de obtener tus primeros satoshis.",
        "Muchas de estas alternativas no requieren grandes cantidades de dinero, sino tiempo, participación o aportar valor a otras personas.",
        "En esta lección veremos formas prácticas de conseguir Bitcoin sin limitarte solo a la compra directa."
      ]
    },
    {
      "heading": "Trabajar y cobrar en Bitcoin",
      "text": [
        "Una de las formas más naturales de obtener Bitcoin es aceptarlo como pago por tu trabajo.",
        "Puedes ofrecer productos, servicios o freelance y acordar que parte o la totalidad del pago sea en BTC.",
        "Cada vez más personas usan Bitcoin como medio de pago internacional para ahorrarse comisiones bancarias y conversiones de divisas."
      ],
      "list": [
        "Trabajo freelance (diseño, programación, marketing, etc.).",
        "Clases, consultorías o mentorías pagadas en Bitcoin.",
        "Venta de productos digitales (ebooks, cursos, plantillas) cobrando en BTC.",
        "Pequeños negocios que aceptan Bitcoin como forma de pago."
      ]
    },
    {
      "heading": "Recompensas y programas de devolución (cashback en BTC)",
      "text": [
        "Algunas plataformas ofrecen recompensas en Bitcoin por usar sus productos o servicios.",
        "En estos casos no estás comprando BTC directamente, sino que los recibes como premio por tus actividades."
      ],
      "list": [
        "Programas de cashback: compras con tarjeta o en tiendas asociadas y recibes un porcentaje en Bitcoin.",
        "Recompensas por usar ciertas apps o servicios que premian tu actividad con pequeñas cantidades de BTC.",
        "Afiliados o referidos: invitas a otras personas a una plataforma y te pagan en Bitcoin."
      ]
    },
    {
      "heading": "Faucets y microrecompensas",
      "text": [
        "Los faucets son páginas o aplicaciones que entregan pequeñas cantidades de Bitcoin (satoshis) a cambio de realizar acciones simples.",
        "Aunque los montos suelen ser muy pequeños, pueden servir para aprender a usar una wallet y hacer tus primeras pruebas."
      ],
      "list": [
        "Resolver captchas o tareas sencillas.",
        "Ver anuncios o contenido promocional.",
        "Realizar pequeñas misiones dentro de una plataforma."
      ]
    },
    {
      "heading": "Juegos y plataformas de incentivos",
      "text": [
        "Algunos juegos y aplicaciones dan satoshis como recompensa por jugar o completar retos.",
        "Estas plataformas suelen estar enfocadas en educación, entrenamiento o simplemente entretenimiento con incentivos en BTC."
      ],
      "list": [
        "Juegos móviles que premian el tiempo de juego con satoshis.",
        "Apps educativas sobre Bitcoin y criptomonedas con recompensas por completar niveles o cuestionarios.",
        "Comunidades que entregan propinas en BTC por participar y aportar valor (por ejemplo, contenido útil, respuestas, aportes técnicos)."
      ]
    },
    {
      "heading": "Donaciones y propinas en Bitcoin",
      "text": [
        "Si creas contenido, ayudas en comunidades o aportas en proyectos abiertos, puedes recibir donaciones en Bitcoin.",
        "Solo necesitas compartir tu dirección o un código QR para que otras personas puedan enviarte satoshis."
      ],
      "list": [
        "Creadoras y creadores de contenido (videos, blogs, podcasts).",
        "Proyectos de código abierto que aceptan donaciones en BTC.",
        "Apoyo entre amigos, familiares o comunidades cripto."
      ]
    },
    {
      "heading": "Siempre necesitas una wallet",
      "text": [
        "En todas estas formas alternativas de obtener Bitcoin hay un punto en común: necesitas un monedero (wallet).",
        "La wallet es la herramienta que te permite recibir, guardar y gestionar los satoshis que consigas.",
        "No importa si los obtienes por trabajo, recompensas, juegos o donaciones: siempre se enviarán a una dirección de tu monedero."
      ]
    },
    {
      "heading": "Consejos de seguridad al obtener Bitcoin",
      "list": [
        "Desconfía de promesas de ganancias rápidas o esquemas que suenan demasiado buenos para ser verdad.",
        "Usa solo plataformas y servicios con buena reputación.",
        "Nunca compartas tu clave privada ni tu frase semilla (seed phrase).",
        "Verifica siempre que la dirección donde recibes o envías sea correcta.",
        "Usa tu wallet únicamente desde dispositivos seguros."
      ]
    },
    {
      "heading": "Resumen",
      "list": [
        "No solo se puede obtener Bitcoin comprándolo: también puedes ganarlo trabajando, jugando, enseñando o participando.",
        "Las recompensas y programas de cashback son una forma interesante de acumular satoshis poco a poco.",
        "Los faucets y juegos sirven para aprender y practicar, aunque los montos sean pequeños.",
        "En todos los casos, una wallet segura es imprescindible para recibir y proteger tus BTC."
      ]
    }
  ]
};

export default CAP24;
